import React, { useRef, useEffect } from "react";
import "./addfundstransak.scss";
import { t } from "../../utils/i18n";

const WithdrawalTransak = () => {
  return (
    <>
      <div className="success-page">
        <div className="success-page__container">
          <h1 className="success-page__title">
            <svg
              version="1.1"
              id="Capa_1"
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
              viewBox="0 0 50 50"
              xmlSpace="preserve"
              className="success-icon _withdraw"
            >
              <circle style={{ fill: "#ff9100" }} cx="25" cy="25" r="25" />
              <polyline
                style={{
                  fill: "none",
                  stroke: "#FFFFFF",
                  strokeWidth: "2",
                  strokeLinecap: "round",
                  strokeLinejoin: "round",
                  strokeMiterlimit: "10",
                }}
                points="38,15 22,33 12,25"
              />
            </svg>
            <br />
            {t("wallets.transak.withdrawal_submitted")}
          </h1>
          <div className="success-page__details">
            <div className="btn-container">
              <button
                className="success-page__cta"
                onClick={() => (window.location.href = "/user/dashboard")}
              >
                {t("wallets.transak.return_to_dashboard")}
              </button>
            </div>
            <p className="success-page__message">
              {t("wallets.transak.processing_before")} <strong>{t("wallets.transak.successful")}</strong>{t("wallets.transak.processing_after")}
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default WithdrawalTransak;
